// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__U6sl-","title":"Images90_title__2hZ8h","images":"Images90_images__2T5Z2"};